/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ListNodePoolsResponse } from '../models';
// @ts-ignore
import type { NodePool } from '../models';
// @ts-ignore
import type { Status } from '../models';
// @ts-ignore
import type { UpdateNodePoolResponse } from '../models';
/**
 * NodePoolsAPIApi - axios parameter creator
 * @export
 */
export const NodePoolsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * add listnodepools rpc
         * @summary Lists NodePools.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The cluster to be registered.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodePoolsAPIListNodePools: async (organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('nodePoolsAPIListNodePools', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('nodePoolsAPIListNodePools', 'clusterId', clusterId)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/node-pools`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing NodePool.
         * @summary Updates a NodePool.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster whose NodePool is being updated.
         * @param {string} name The name of the NodePool being updated.
         * @param {NodePool} nodePool 
         * @param {string} [expectedResourceVersion] The resourceVersion observed by the UI on the prior read.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodePoolsAPIUpdateNodePool: async (organizationId: string, clusterId: string, name: string, nodePool: NodePool, expectedResourceVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('nodePoolsAPIUpdateNodePool', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('nodePoolsAPIUpdateNodePool', 'clusterId', clusterId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('nodePoolsAPIUpdateNodePool', 'name', name)
            // verify required parameter 'nodePool' is not null or undefined
            assertParamExists('nodePoolsAPIUpdateNodePool', 'nodePool', nodePool)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/node-pools/{name}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (expectedResourceVersion !== undefined) {
                localVarQueryParameter['expectedResourceVersion'] = expectedResourceVersion;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nodePool, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NodePoolsAPIApi - functional programming interface
 * @export
 */
export const NodePoolsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NodePoolsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * add listnodepools rpc
         * @summary Lists NodePools.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The cluster to be registered.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodePoolsAPIListNodePools(organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListNodePoolsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodePoolsAPIListNodePools(organizationId, clusterId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodePoolsAPIApi.nodePoolsAPIListNodePools']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates an existing NodePool.
         * @summary Updates a NodePool.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster whose NodePool is being updated.
         * @param {string} name The name of the NodePool being updated.
         * @param {NodePool} nodePool 
         * @param {string} [expectedResourceVersion] The resourceVersion observed by the UI on the prior read.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodePoolsAPIUpdateNodePool(organizationId: string, clusterId: string, name: string, nodePool: NodePool, expectedResourceVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateNodePoolResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodePoolsAPIUpdateNodePool(organizationId, clusterId, name, nodePool, expectedResourceVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodePoolsAPIApi.nodePoolsAPIUpdateNodePool']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NodePoolsAPIApi - factory interface
 * @export
 */
export const NodePoolsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NodePoolsAPIApiFp(configuration)
    return {
        /**
         * add listnodepools rpc
         * @summary Lists NodePools.
         * @param {NodePoolsAPIApiNodePoolsAPIListNodePoolsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodePoolsAPIListNodePools(requestParameters: NodePoolsAPIApiNodePoolsAPIListNodePoolsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListNodePoolsResponse> {
            return localVarFp.nodePoolsAPIListNodePools(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing NodePool.
         * @summary Updates a NodePool.
         * @param {NodePoolsAPIApiNodePoolsAPIUpdateNodePoolRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodePoolsAPIUpdateNodePool(requestParameters: NodePoolsAPIApiNodePoolsAPIUpdateNodePoolRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateNodePoolResponse> {
            return localVarFp.nodePoolsAPIUpdateNodePool(requestParameters.organizationId, requestParameters.clusterId, requestParameters.name, requestParameters.nodePool, requestParameters.expectedResourceVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for nodePoolsAPIListNodePools operation in NodePoolsAPIApi.
 * @export
 * @interface NodePoolsAPIApiNodePoolsAPIListNodePoolsRequest
 */
export interface NodePoolsAPIApiNodePoolsAPIListNodePoolsRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof NodePoolsAPIApiNodePoolsAPIListNodePools
     */
    readonly organizationId: string

    /**
     * The cluster to be registered.
     * @type {string}
     * @memberof NodePoolsAPIApiNodePoolsAPIListNodePools
     */
    readonly clusterId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof NodePoolsAPIApiNodePoolsAPIListNodePools
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof NodePoolsAPIApiNodePoolsAPIListNodePools
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for nodePoolsAPIUpdateNodePool operation in NodePoolsAPIApi.
 * @export
 * @interface NodePoolsAPIApiNodePoolsAPIUpdateNodePoolRequest
 */
export interface NodePoolsAPIApiNodePoolsAPIUpdateNodePoolRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof NodePoolsAPIApiNodePoolsAPIUpdateNodePool
     */
    readonly organizationId: string

    /**
     * The ID of the cluster whose NodePool is being updated.
     * @type {string}
     * @memberof NodePoolsAPIApiNodePoolsAPIUpdateNodePool
     */
    readonly clusterId: string

    /**
     * The name of the NodePool being updated.
     * @type {string}
     * @memberof NodePoolsAPIApiNodePoolsAPIUpdateNodePool
     */
    readonly name: string

    /**
     * 
     * @type {NodePool}
     * @memberof NodePoolsAPIApiNodePoolsAPIUpdateNodePool
     */
    readonly nodePool: NodePool

    /**
     * The resourceVersion observed by the UI on the prior read.
     * @type {string}
     * @memberof NodePoolsAPIApiNodePoolsAPIUpdateNodePool
     */
    readonly expectedResourceVersion?: string
}

/**
 * NodePoolsAPIApi - object-oriented interface
 * @export
 * @class NodePoolsAPIApi
 * @extends {BaseAPI}
 */
export class NodePoolsAPIApi extends BaseAPI {
    /**
     * add listnodepools rpc
     * @summary Lists NodePools.
     * @param {NodePoolsAPIApiNodePoolsAPIListNodePoolsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodePoolsAPIApi
     */
    public nodePoolsAPIListNodePools(requestParameters: NodePoolsAPIApiNodePoolsAPIListNodePoolsRequest, options?: RawAxiosRequestConfig) {
        return NodePoolsAPIApiFp(this.configuration).nodePoolsAPIListNodePools(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing NodePool.
     * @summary Updates a NodePool.
     * @param {NodePoolsAPIApiNodePoolsAPIUpdateNodePoolRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodePoolsAPIApi
     */
    public nodePoolsAPIUpdateNodePool(requestParameters: NodePoolsAPIApiNodePoolsAPIUpdateNodePoolRequest, options?: RawAxiosRequestConfig) {
        return NodePoolsAPIApiFp(this.configuration).nodePoolsAPIUpdateNodePool(requestParameters.organizationId, requestParameters.clusterId, requestParameters.name, requestParameters.nodePool, requestParameters.expectedResourceVersion, options).then((request) => request(this.axios, this.basePath));
    }
}

